module.exports = __webpack_public_path__ + "static/img/player_head_1.f622fd7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_1.jpg
// module id = zvt5
// module chunks = 1